var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.75L7.62369 8.03658C8.11957 8.3837 8.36751 8.55726 8.6372 8.62448C8.87542 8.68386 9.12458 8.68386 9.3628 8.62448C9.63249 8.55726 9.88043 8.3837 10.3763 8.03658L16.5 3.75M5.1 13.5H12.9C14.1601 13.5 14.7902 13.5 15.2715 13.2548C15.6948 13.039 16.039 12.6948 16.2548 12.2715C16.5 11.7902 16.5 11.1601 16.5 9.9V5.1C16.5 3.83988 16.5 3.20982 16.2548 2.72852C16.039 2.30516 15.6948 1.96095 15.2715 1.74524C14.7902 1.5 14.1601 1.5 12.9 1.5H5.1C3.83988 1.5 3.20982 1.5 2.72852 1.74524C2.30516 1.96095 1.96095 2.30516 1.74524 2.72852C1.5 3.20982 1.5 3.83988 1.5 5.1V9.9C1.5 11.1601 1.5 11.7902 1.74524 12.2715C1.96095 12.6948 2.30516 13.039 2.72852 13.2548C3.20982 13.5 3.83988 13.5 5.1 13.5Z",
    stroke: "#8D94A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.555c7e4b662a9148e2206db0857b9f0b.svg";
export { ForwardRef as ReactComponent };